var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "RightCaret_svg__MuiSvgIcon-root RightCaret_svg__icon-0-3-78",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    fontSize: "1.5rem"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
  })));
}

export default SvgRightCaret;